"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ApproveModal = _interopRequireDefault(require("./ApproveModal.vue"));
var _member = require("@/api/member");
var _ghn = require("@/api/ghn");
var MemberDialog = /*#__PURE__*/function (_Vue) {
  function MemberDialog() {
    var _this;
    (0, _classCallCheck2.default)(this, MemberDialog);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, MemberDialog, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "tabName", "info");
    (0, _defineProperty2.default)(_this, "loadingButton", false);
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    (0, _defineProperty2.default)(_this, "rules", {});
    return _this;
  }
  (0, _inherits2.default)(MemberDialog, _Vue);
  return (0, _createClass2.default)(MemberDialog, [{
    key: "created",
    value: function created() {
      this.fetchCities();
    }
  }, {
    key: "watchCity",
    value: function watchCity(val) {
      if (!val) {
        return;
      }
      this.fetchDistricts();
    }
  }, {
    key: "watchDistrictId",
    value: function watchDistrictId() {
      this.fetchWards();
    }
  }, {
    key: "handleChangeWard",
    value: function handleChangeWard() {
      var _this2 = this;
      var ward = this.wards.find(function (e) {
        return e.WardCode == _this2.form.receiverWardCode;
      });
      this.form.receiverWardName = ward && ward.WardName;
    }
  }, {
    key: "handleChangeDistrict",
    value: function handleChangeDistrict() {
      var _this3 = this;
      this.form.receiverWardCode = null;
      var district = this.districts.find(function (e) {
        return e.DistrictID == _this3.form.receiverDistrictId;
      });
      this.form.receiverDistrictName = district && district.DistrictName;
      this.form.receiverDistrictCode = district && district.Code;
    }
  }, {
    key: "handleChangeCity",
    value: function handleChangeCity() {
      var _this4 = this;
      this.$set(this.form, "receiverDistrictId", null);
      this.$set(this.form, "receiverWardCode", null);
      var city = this.cities.find(function (e) {
        return e.ProvinceID == _this4.form.receiverCityId;
      });
      this.form.receiverCityName = city && city.ProvinceName;
      this.form.receiverCityCode = city && city.Code;
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _ghn.ghnApi.findCity();
            case 2:
              res = _context.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _ghn.ghnApi.findDistrict({
                province_id: this.form.receiverCityId
              });
            case 2:
              res = _context2.sent;
              this.districts = res.data.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _ghn.ghnApi.findWard({
                district_id: this.form.receiverDistrictId
              });
            case 2:
              res = _context3.sent;
              this.wards = res.data.data;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchWards() {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.$confirm("Confirm delete this member?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.loadingButton = true;
              _context4.next = 6;
              return _member.memberApi.delete(this.form.id);
            case 6:
              this.$notify.success({
                title: "Delete member",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context4.prev = 9;
              this.loadingButton = false;
              return _context4.finish(9);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleUpdateData",
    value: function () {
      var _handleUpdateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              this.loadingButton = true;
              data = {
                member: this.form
              };
              _context5.next = 5;
              return _member.memberApi.update(this.form.id, data);
            case 5:
              this.$notify.success({
                title: "Update member",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 8:
              _context5.prev = 8;
              this.loadingButton = false;
              return _context5.finish(8);
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0,, 8, 11]]);
      }));
      function handleUpdateData() {
        return _handleUpdateData.apply(this, arguments);
      }
      return handleUpdateData;
    }()
  }, {
    key: "handleApprove",
    value: function () {
      var _handleApprove = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs.approveModal.handleApprove(this.form);
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleApprove() {
        return _handleApprove.apply(this, arguments);
      }
      return handleApprove;
    }()
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      this.status = "update";
      this.visible = true;
      this.tabName = "info";
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverCityId", {
  deep: true,
  immediate: true
})], MemberDialog.prototype, "watchCity", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.receiverDistrictId", {
  deep: true,
  immediate: true
})], MemberDialog.prototype, "watchDistrictId", null);
MemberDialog = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ApproveModal: _ApproveModal.default
  }
})], MemberDialog);
var _default = exports.default = MemberDialog;